import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Header from '../components'
import '../styles/header.scss'

const mapStateToProps = (state) => ({
  merchant: state.merchant,
  userName: state.user.userName,
  redirectUrl: '/', // state.session.redirectTo,
})

const mapDispatchToProps = () => ({
})

const Index = connect(mapStateToProps, mapDispatchToProps)(Header)

export default withRouter(Index)
